import {OauthService} from './oauth.service';
import {Subject} from 'rxjs/Subject';
import {Injectable} from '@angular/core';
import {App} from 'ionic-angular';
import {Http, ResponseContentType} from '@angular/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class PieceJointeService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
    this.loader.next(true); // init custom loader
  }

  download(id) {
    const url = this.Routing.generate('api_get_piece_jointe', {'_format': 'json', 'pieceJointe': id}, true);

    return this.http
      // .get(`${url}/${id}`, {headers: this.updateHeaders(), responseType: ResponseContentType.Blob}, )
      .get(`${url}`, {headers: this.updateHeaders(), responseType: ResponseContentType.Blob}, )
      .map(response => {
        return {
          data: response.blob()
        };
      });
  }

  getBlogArticleAttachmentUrl(id: number, image: number, ticket: string) {
    const params = {
      '_format': 'json',
      'blogArticle': id,
      'pieceJointe': image,
      'ticket': ticket,
    };

    return this.Routing.generate('api_get_blog-articles_pj', params, true);
  }

  getFolderLineAttachment(idLine: number, idFolder: number, idAttachment: number, ticket: string) {
    const params = {
      '_format': 'json',
      'dossierPrestation': idFolder,
      'ligne': idLine,
      'pieceJointe': idAttachment,
      'ticket': ticket,
    };

    return this.Routing.generate('api_get_dossier_prestation_pj', params, true);
  }

  getBeneficiairePieceJointeUrl(beneficiaire: number, pieceJointe: number, ticket: string): string {
    const params = {
      '_format': 'json',
      'beneficiaire': beneficiaire,
      'pieceJointe': pieceJointe,
      'ticket': ticket,
    };

    return this.Routing.generate('api_get_beneficiaire_pj', params, true);
  }

  getDownloadTicket(id: number): Observable<any> {
    const url = this.Routing.generate('api_get_piece_jointe_download_ticket', {'_format': 'json', 'pieceJointe': id}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/pieceJointe.service.ts